import { VueExtension } from "../../utils/extensions/vue";
import Swiper from './swiper.jsx'
import './swiper.scss'

VueExtension.WithInstall(Swiper)

export default Swiper